<template>
    <popup class="tracking-popup">
        <div class="track-wrap wrap-common rel">
            <form  @submit.prevent="handleSave(trackInfo)">
                <div class="track-input">
                    <div class="item" >
                        <input type="text" placeholder="Goole Analytics Tracking ID"
                               :class="{'error-border': validation.hasError('trackInfo.trackingId') || errTracking }"
                               v-model="trackInfo.trackingId">
                        <p class="error">{{ validation.firstError('trackInfo.trackingId') }}</p>
                    </div>
                    <p class="else tc">OR</p>
                    <div class="item">
                        <input type="text" placeholder="StatCounter Project ID"
                               :class="{'error-border': validation.hasError('trackInfo.projectId') || errProject }"
                               v-model="trackInfo.projectId">
                        <p class="error">{{ validation.firstError('trackInfo.projectId')}}</p>
                    </div>
                    <div class="item">
                        <input type="text" placeholder="StatCounter Security Code"
                               :class="{'error-border': validation.hasError('trackInfo.SecurityCode') || errSecurity }"
                               v-model="trackInfo.SecurityCode">
                        <p class="error">{{ validation.firstError('trackInfo.SecurityCode') }}</p>
                    </div>
                </div>
                <p class="tc">
                    <button class="track-btn btn" type="submit" :style="disableBtn">Save</button>
                </p>
            </form>
            <p class="close-btn btn-common" @click="handleClose">
             <i class="icon-close-line iconfont"></i>
            </p>
        </div>
    </popup>
</template>

<script>

import adminService from '../service/adminService';
import {validateError} from '../../common/utils/errors';
import popup from "./popup.vue";
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
import loading from "../../common/utils/loading";
Vue.use(SimpleVueValidation);

export default {
    components: {
      popup,
    },
    data() {
        return {
          close:true,
          trackInfo:{
            trackingId:'',
            projectId:'',
            SecurityCode:'',
          },
          is_loading: false,
          validateTracking: false,
          validateProject: false,
          validateSecurity: false,
          errTracking: '',
          errProject: '',
          errSecurity: ''
        }
    },
    props: {
      options: {
        type: Object,
        default() {
          return {
            ga_trakcing_id: null,
            statCounter_project_id: null,
            statCounter_security_id: null,
          };
        }
      }
    },
  computed:{
    disableBtn() {
      if(this.trackInfo.trackingId){
        return {
          opacity: 1
        };
      }
      if(this.trackInfo.projectId && this.trackInfo.SecurityCode) {
        return {
          opacity: 1
        }
      }
      else {
        return {
          opacity: .3
        }
      }
    },
  },
    methods: {

        handleClose() {
            this.$emit('close',this.close)
        },
        handleSave:function(trackInfo) {

          this.$validate()
              .then((success)=>{
                if(success){
                  this.clearErrMsg();
                  if(this.is_loading) return;
                  this.is_loading = true;
                  loading.show();
                  adminService.saveTracking( trackInfo.trackingId, trackInfo.projectId, trackInfo.SecurityCode)
                      .then(res => {
                        console.log(res);
                        this.$emit("update", {
                          "ga_trakcing_id" : this.trackInfo.trackingId,
                          "statCounter_project_id" : this.trackInfo.projectId,
                          "statCounter_security_id" : this.trackInfo.SecurityCode,
                        });
                        this.handleClose();

                      })
                      .catch((err) => {
                        if(err instanceof validateError){
                          const validate = err.getError();
                          if(validate.ga_trakcing_id){
                            this.errTracking = validate.ga_trakcing_id;
                            this.validateTracking = true;
                          }
                          if(validate.statCounter_project_id){
                            this.errProject = validate.statCounter_project_id;
                            this.validateProject = true;
                          }
                          if(validate.statCounter_security_id){
                            this.errSecurity = validate.statCounter_security_id;
                            this.validateSecurity = true;
                          }
                        }
                      })
                      .finally(()=>{
                        this.is_loading = false;
                        loading.hide();
                      })
                }
                return;
              })

        },

      //清除校验信息
      clearErrMsg: function () {
        this.validateTracking = false,
            this.validateProject = false,
            this.validateSecurity = false,
            this.errTracking = '',
            this.errProject = '',
            this.errSecurity = ''
      },
    },

    mounted() {
      this.trackInfo.trackingId = this.options.ga_trakcing_id || this.trackInfo.trackingId;
      this.trackInfo.projectId = this.options.statCounter_project_id || this.trackInfo.projectId;
      this.trackInfo.SecurityCode = this.options.statCounter_security_id || this.trackInfo.SecurityCode;
    },
    validators:{
      'trackInfo.trackingId': function (value) {

        if(this.trackInfo.projectId && this.trackInfo.SecurityCode){
          return ;
        }
        return Validator.value(value).required('google id or statcounter');

      },
      'trackInfo.projectId': function (value) {
        if(this.trackInfo.trackingId){
          return ;
        }
        return Validator.value(value).required('google id or statcounter');
      },
      'trackInfo.SecurityCode': function (value) {
        if(this.trackInfo.trackingId){
          return ;
        }
        return Validator.value(value).required('google id or statcounter');
      }
    }
}
</script>

